import ReactGA from 'react-ga4'

export default function track () {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(process.env.REACT_APP_TRACKING_ID)
    ReactGA.pageview(window.location.pathname)
  }
}
